module.exports = __webpack_public_path__ + "img/planner.0e6f9293.png";